import { buildUrl, VIDEO_API_URL } from "../config/urls";
import useSWR from "swr";

export const useVideoRecord = (url: string) => {
  return useSWR(url);
};

export const useVideoData = (applicationId: string) => {
  return useSWR(buildUrl(VIDEO_API_URL, { applicationId }));
};
